<template>
  <rounded-card :head-text="$t('login.terms_of_service')">
    <!-- Agreement viewer -->
    <div class="content overflow-y-scroll mx-8 p-8 rounded-lg" v-html="$t('terms.terms')"></div>
    <c-button class="mt-5 mb-8" @click="$emit('update:agreementsPage', false)">
      <span>{{ $t('login.agreements_button') }}</span>
    </c-button>
  </rounded-card>
</template>

<script>
import RoundedCard from '@/components/common/RoundedCard.vue';
import CButton from '@/components/common/CButton.vue';

export default {
  components: {
    RoundedCard,
    CButton,
  },
  props: {
    agreementsPage: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 70vh;
  background-color: #f6f7ff;
}
</style>
